// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__rTaLt","loading":"Spinner_loading__0Oj3V"};